import React, { useEffect, useRef, useState } from "react";
import SuperTableV2 from "../../SuperTableV2";
import { Button, Modal } from "react-bootstrap";
import CustomCalender from "./CustomCalendar";
import Swal from "sweetalert2";
import { CalendarServices } from "./CalendarServices";

const CalendarTableList = ({ show, setShow, calendars, setCalendars, loadCaledar }) => {
  const [loading, setLoading]= useState(false)
  const [calendarToEdit, setCalendarToEdit]=useState('')

  const handleCloseCustomCalendar = () => {
    setCalendarToEdit('')
  };

  const handleDeleteCalendar = async (IdCalendar)=>{ 
    const result  = await Swal.fire({
      title:"¿Estás seguro?",
      text:"Al eliminar este calendario, quedara activo el calendario base por defecto y afectara a su proyecto",
      icon:"warning",
      showCancelButton:true, 
      confirmButtonColor:'#d33',
      cancelButtonColor:"#3085d6",
      confirmButtonText:"Sí,eliminar",
      cancelButtonText:"Cancelar"

    })

    if(result.isConfirmed){ 
      try {
        setLoading(true)
        await CalendarServices.deleteCalendar(IdCalendar)
        setCalendars( preCalendars => preCalendars.filter(calendar => calendar.IdCalendario !== IdCalendar))

        Swal.fire('¡Eliminado', 'El calendario ha sido eliminado exitosamente', 'success')

      } catch (error) {
        Swal.fire('Error',error.message,"error")
      } finally {
        setLoading(false)
      }
    }
  }

  const handleUpdateCalendar= async(IdCalendar)=>{
    setCalendarToEdit(calendars.filter((cale)=> cale.IdCalendario == IdCalendar))
    setShow(true);
  }
  const columns = [
    {
      caption: "Nombre",
      selector: "Nombre",
      width: 550,
    },
    {
      caption: "Creado Por",
      selector: "Creador",
      width: 200,
    },
    {
      caption: "Editar",
      selector: "editar",
      customRender: (row) => {
        return (
          <Button
          variant="info"
          onClick={()=> handleUpdateCalendar(row.data.IdCalendario) }
          disabled={loading}
          style={{cursor: loading? 'not-allowed':'pointer', opacity	: loading ? 0.5: 1}}
        >
          <i className="fa fa-edit"></i>
        </Button>
        );
      },
    },

    {
      caption: "Eliminar",
      selector: "eliminar",
      customRender: (row) => {
        return (
          <Button
            onClick={()=> handleDeleteCalendar(row.data.IdCalendario) }
            disabled={loading}
            style={{cursor: loading? 'not-allowed':'pointer', opacity	: loading ? 0.5: 1}}
          >
            <i className="fa fa-trash"></i>
          </Button>
        );
      },
    },
  ];

  return (
    <>
      <div>
        <SuperTableV2
          data={calendars.length > 0 ? calendars : []}
          columns={columns}
        />
      </div>
      <div className="d-flex justify-content-end">
        <Button
          onClick={() => {
            setShow(true);
          }}
          variant="success"
          size="sm"
        >
          Crear Calendario
        </Button>
      </div>

      <Modal
        show={show}
        onHide={handleCloseCustomCalendar}
        backdrop="static"
        size="lg"
        keyboard={false}
      >
        <Modal.Header className="py-3 d-flex justify-content-between">
          <h5 className="mb-0">Configurar Calendario Personalizado</h5>
          <Button
            onClick={(e) => {
              setCalendarToEdit('')
              setShow(false);
            }}
            variant="light"
          >
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          <CustomCalender
            setShow={setShow}
            show = {show}
            calendarToEdit={calendarToEdit}
            setCalendarToEdit ={setCalendarToEdit}
            loadCaledar={loadCaledar}
            setCalendars={setCalendars} 
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CalendarTableList;
